// Test calculation logic - moved from backend to frontend

export const calculateNaturalIntelligence = (answers) => {
  // Типы натуры согласно Excel файлу
  const categories = {
    "Защитный характер": [1, 5, 10, 16, 23, 34, 42, 53, 68],
    "Воспитательный характер": [3, 9, 13, 22, 35, 48, 51, 59, 71],
    "Административный характер": [7, 15, 21, 26, 29, 31, 36, 62, 75],
    "Творческая натура": [4, 6, 14, 27, 33, 37, 45, 54, 70],
    "Исцеляющая (целебная) природа": [11, 17, 30, 41, 43, 46, 58, 67, 74],
    "Развлекательный характер": [12, 25, 39, 44, 49, 52, 55, 64, 78],
    "Обеспечивающая Природа": [8, 20, 32, 38, 50, 57, 63, 72, 79],
    "Предпринимательский характер": [2, 18, 40, 47, 60, 65, 73, 76, 80],
    "Авантюрная натура": [19, 24, 28, 56, 61, 66, 69, 77, 81]
  };

  const results = {};
  for (const [category, questions] of Object.entries(categories)) {
    const totalScore = questions.reduce((sum, q) => sum + (answers[q] || 0), 0);
    const maxPossible = questions.length * 2;
    const percentage = maxPossible > 0 ? (totalScore / maxPossible) * 100 : 0;
    
    results[category] = {
      score: totalScore,
      percentage: Math.round(percentage * 100) / 100,
      questions_count: questions.length,
      coefficient_score: Math.round(totalScore * 1.1 * 100) / 100 // Применяем коэффициент 1.1 как в Excel
    };
  }

  const dominantType = Object.keys(results).reduce((a, b) => 
    results[a].percentage > results[b].percentage ? a : b
  );

  return {
    allCategories: results,
    dominantType,
    dominantPercentage: results[dominantType].percentage,
    // summary: `Ваш доминирующий тип природного интеллекта: ${dominantType} (${results[dominantType].percentage}%)`,
    answers: answers // Сохраняем исходные ответы для Excel
  };
};

export const calculateIntelligenceTypes = (answers) => {
  // Типы интеллекта согласно Excel файлу
  const categories = {
    "Лингвистический": [5, 12, 25, 26, 43, 49, 56, 64, 76],
    "Математико-логический": [6, 14, 29, 35, 38, 47, 59, 67, 77],
    "Визуально-пространственный": [2, 24, 31, 55, 68, 71, 75, 81, 88],
    "Музыкальный": [4, 13, 22, 34, 48, 54, 69, 82, 85],
    "Межличностный": [3, 11, 16, 30, 41, 45, 61, 70, 83],
    "Внутриличностный": [10, 18, 20, 33, 50, 62, 74, 84, 89],
    "Грубый телесный": [7, 19, 28, 32, 36, 42, 58, 79, 87],
    "Прекрасный телесный": [1, 9, 17, 23, 37, 40, 51, 63, 78],
    "Визуально-графический": [15, 27, 44, 53, 57, 60, 66, 73, 80],
    "Натуралистический (природный)": [8, 21, 39, 46, 52, 65, 72, 86, 90]
  };

  const results = {};
  for (const [category, questions] of Object.entries(categories)) {
    const totalScore = questions.reduce((sum, q) => sum + (answers[q] || 0), 0);
    const total = questions.length;
    const percentage = total > 0 ? (totalScore / (total * 2)) * 100 : 0; // Максимальное значение 2 на вопрос
    
    results[category] = {
      score: totalScore,
      total,
      percentage: Math.round(percentage * 100) / 100,
      coefficient_score: Math.round(totalScore * 1.1 * 100) / 100 // Применяем коэффициент 1.1 как в Excel
    };
  }

  const sortedResults = Object.entries(results).sort((a, b) => b[1].percentage - a[1].percentage);
  const topTypes = sortedResults.slice(0, 3).map(([type, data]) => ({
    type,
    percentage: data.percentage
  }));

  return {
    allCategories: results,
    topTypes,
    summary: `Ваши ведущие типы интеллекта: ${topTypes.map(t => `${t.type} (${t.percentage}%)`).join(', ')}`,
    answers: answers // Сохраняем исходные ответы для Excel
  };
};

export const calculateBelbin = (answers) => {
  const roleMapping = {
    1: {"a": "Исследователь ресурсов", "b": "Коллективист", "c": "Генератор идей", "d": "Формирователь", "e": "Исполнитель", "f": "Координатор", "g": "Доводчик", "h": "Оценщик"},
    2: {"a": "Координатор", "b": "Коллективист", "c": "Генератор идей", "d": "Оценщик", "e": "Формирователь", "f": "Исследователь ресурсов", "g": "Исполнитель", "h": "Доводчик"},
    3: {"a": "Координатор", "b": "Доводчик", "c": "Формирователь", "d": "Генератор идей", "e": "Коллективист", "f": "Исследователь ресурсов", "g": "Оценщик", "h": "Исполнитель"},
    4: {"a": "Коллективист", "b": "Формирователь", "c": "Оценщик", "d": "Исполнитель", "e": "Генератор идей", "f": "Доводчик", "g": "Исследователь ресурсов", "h": "Координатор"},
    5: {"a": "Оценщик", "b": "Исполнитель", "c": "Коллективист", "d": "Формирователь", "e": "Исследователь ресурсов", "f": "Координатор", "g": "Доводчик", "h": "Генератор идей"},
    6: {"a": "Генератор идей", "b": "Коллективист", "c": "Координатор", "d": "Формирователь", "e": "Доводчик", "f": "Исследователь ресурсов", "g": "Координатор", "h": "Исполнитель"},
    7: {"a": "Формирователь", "b": "Оценщик", "c": "Доводчик", "d": "Генератор идей", "e": "Координатор", "f": "Исследователь ресурсов", "g": "Исследователь ресурсов", "h": "Коллективист"},
    8: {"a": "Исследователь ресурсов", "b": "Координатор", "c": "Исполнитель", "d": "Формирователь", "e": "Генератор идей", "f": "Коллективист", "g": "Оценщик", "h": "Доводчик"}
  };

  const roles = {
    "Исполнитель": 0,
    "Координатор": 0,
    "Формирователь": 0,
    "Генератор идей": 0,
    "Исследователь ресурсов": 0,
    "Оценщик": 0,
    "Коллективист": 0,
    "Доводчик": 0
  };

  // Calculate scores for each role
  for (const [questionId, questionAnswers] of Object.entries(answers)) {
    const qId = parseInt(questionId);
    if (roleMapping[qId]) {
      for (const [option, score] of Object.entries(questionAnswers)) {
        if (roleMapping[qId][option]) {
          const roleName = roleMapping[qId][option];
          roles[roleName] += score;
        }
      }
    }
  }

  const sortedRoles = Object.entries(roles).sort((a, b) => b[1] - a[1]);
  const topRoles = sortedRoles.slice(0, 3).map(([role, score]) => ({ role, score }));

  return {
    allRoles: roles,
    topRoles,
    summary: `Ваши ведущие командные роли: ${topRoles.map(r => `${r.role} (${r.score} баллов)`).join(', ')}`
  };
};

export const calculateORS = (answers) => {
  const scoring = {
    1: {"a": "V", "b": "A", "c": "K", "d": "D"},
    2: {"a": "A", "b": "D", "c": "K", "d": "V"},
    3: {"a": "D", "b": "K", "c": "V", "d": "A"},
    4: {"a": "V", "b": "K", "c": "A", "d": "D"},
    5: {"a": "K", "b": "D", "c": "V", "d": "A"},
    6: {"a": "A", "b": "V", "c": "K", "d": "D"},
    7: {"a": "D", "b": "V", "c": "K", "d": "A"},
    8: {"a": "V", "b": "D", "c": "A", "d": "K"},
    9: {"a": "K", "b": "V", "c": "D", "d": "A"},
    10: {"a": "A", "b": "V", "c": "K", "d": "D"},
    11: {"a": "D", "b": "A", "c": "K", "d": "V"},
    12: {"a": "K", "b": "V", "c": "A", "d": "D"},
    13: {"a": "V", "b": "A", "c": "D", "d": "K"},
    14: {"a": "D", "b": "K", "c": "V", "d": "A"},
    15: {"a": "V", "b": "D", "c": "A", "d": "K"}
  };

  const systemScores = {"V": 0, "A": 0, "K": 0, "D": 0};

  for (const [questionId, answer] of Object.entries(answers)) {
    const qId = parseInt(questionId);
    if (qId <= 15 && scoring[qId] && scoring[qId][answer]) {
      const system = scoring[qId][answer];
      systemScores[system] += 1;
    }
  }

  const dominantSystem = Object.keys(systemScores).reduce((a, b) => 
    systemScores[a] > systemScores[b] ? a : b
  );

  const systemNames = {
    "V": "Визуальная",
    "A": "Аудиальная", 
    "K": "Кинестетическая",
    "D": "Дигитальная"
  };

  const allSystems = {};
  for (const [key, value] of Object.entries(systemScores)) {
    allSystems[systemNames[key]] = value;
  }

  // Create top systems array
  const sortedSystems = Object.entries(allSystems).sort((a, b) => b[1] - a[1]);
  const topSystems = sortedSystems.slice(0, 3).map(([system, score]) => ({
    system,
    score
  }));

  return {
    allSystems,
    dominantSystem: systemNames[dominantSystem],
    topSystems,
    // summary: `Ваша доминирующая репрезентативная система: ${systemNames[dominantSystem]} (${systemScores[dominantSystem]} баллов из 15)`
  };
};

export const calculateSubtype = (answers) => {
  const subtypeScores = {"a": 0, "b": 0, "c": 0};

  for (const answer of Object.values(answers)) {
    if (subtypeScores.hasOwnProperty(answer)) {
      subtypeScores[answer] += 1;
    }
  }

  const dominantSubtype = Object.keys(subtypeScores).reduce((a, b) => 
    subtypeScores[a] > subtypeScores[b] ? a : b
  );

  const subtypeNames = {
    "a": "Самосохранение (SP)",
    "b": "Сексуальный (SX)",
    "c": "Социальный (SO)"
  };

  const subtypeDescriptions = {
    "a": "Фокус на безопасности, здоровье, комфорте и материальной стабильности",
    "b": "Фокус на интенсивных отношениях, привлекательности и личных связях",
    "c": "Фокус на групповой динамике, статусе и социальных связях"
  };

  const sortedSubtypes = Object.entries(subtypeScores).sort((a, b) => b[1] - a[1]);
  const topSubtypes = sortedSubtypes.slice(0, 2).map(([key, score]) => ({
    subtype: subtypeNames[key],
    score
  }));

  const allSubtypes = {};
  for (const [key, value] of Object.entries(subtypeScores)) {
    allSubtypes[subtypeNames[key]] = value;
  }

  return {
    allSubtypes,
    dominantSubtype: subtypeNames[dominantSubtype],
    description: subtypeDescriptions[dominantSubtype],
    topSubtypes,
    // summary: `Ваш доминирующий подтип: ${subtypeNames[dominantSubtype]} (${subtypeScores[dominantSubtype]} баллов)`
  };
};